export const povileThemeColors = {
  primary: '#e07900',
  secondary: '#e07900',
  h1: '#e07900',
  success: '#96df7a',
  info: '#3bcfd5',
  warning: '#f3b258',
  danger: '#dd3570',
  dark: '#2a294',
  activeColor: '#2A294D',
  contrastActiveColor: '#FFFFFF',
  secondColor: '#515084',
  loaderFirst: '#7EE16B',
  loaderSecond: '#515084',
  loaderThird: '#014ed8',
  displaySignupTitle: 'none',
  roundedGrey: '#e07900',
};
